import { NavBarWrapper } from '.';
import { WorkspaceSelector } from '../SideBar/WorkspaceSelector';

function PlansPageNavBar() {
	return (
		<NavBarWrapper>
			<WorkspaceSelector />
		</NavBarWrapper>
	);
}

export default PlansPageNavBar;
